export default function Filter({ className }) {
    return (
        <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.74427 18.3333L11.7245 16.4599V11.5503L17.9659 5.22047C18.2011 4.9833 18.3332 4.65778 18.3332 4.3169V2.93129C18.3332 2.23225 17.7846 1.66667 17.1078 1.66667H2.89191C2.21506 1.66667 1.6665 2.23225 1.6665 2.93129V4.34859C1.6665 4.67026 1.78458 4.97946 1.99749 5.21375L7.74427 11.5503V18.3333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
